<template>
  <sweet-modal
    overlay-theme="dark"
    hide-close-button
    ref="modal"
    enable-mobile-fullscreen
    class="no-padding-content"
    :width="$mq == 'mobile' ? '100%' : '50%'"
    @open="onModalOpen"
    @close="modalClosed"
  >
    <div class="bg-modal-gradient flex justify-between items-center p-6">
      <div class="text-white text-3xl">
        <i class="fa fa-calendar mr-4"></i> Add an event
      </div>
      <div>
        <button
          type="button"
          class="text-white text-2xl hover:text-grey"
          @click="$refs.modal.close()"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <div class="p-6">
      <form
        @submit.prevent="postEvent"
        data-vv-scope="add-event"
        enctype="multipart/form-data"
      >
        <div class="w-full text-left my-4">
          <div class="flex justify-between">
            <label class="font-medium"
              >Title <span class="text-red">*</span></label
            >
            <label class="text-red text-sm font-medium">* Required info</label>
          </div>
          <input
            type="text"
            class="w-full h-10 border rounded px-3 mt-1"
            v-model="add_event.title"
            v-validate="'required'"
            name="event_title"
            tabindex="1"
            :class="{ 'border-red': errors.has('add-event.event_title') }"
          />
          <div
            v-show="errors.has('add-event.event_title')"
            class="text-red text-sm mt-1"
          >
            {{ errors.first("add-event.event_title") }}
          </div>
        </div>

        <div class="w-full text-left mt-4">
          <label class="font-medium"
            >Event Details <span class="text-red">*</span></label
          >
          <textarea
            type="text"
            class="w-full border rounded py-2 px-3 mt-1"
            v-model="add_event.description"
            v-validate="'required'"
            name="description"
            tabindex="2"
            :class="{ 'border-red': errors.has('add-event.description') }"
          ></textarea>
          <div
            v-show="errors.has('add-event.description')"
            class="text-red text-sm mt-1"
          >
            {{ errors.first("add-event.description") }}
          </div>
        </div>

        <div class="w-full text-left flex flex-col md:flex-row mb-4 mt-2">
          <div class="flex-1 mr-0 md:mr-2">
            <label class="font-medium"
              >Start <span class="text-red">*</span></label
            >
            <div class="flex mt-2">
              <flat-pickr
                v-if="isModalOpen"
                :config="flatPickrConfig"
                :events="[
                  'on-change',
                  'on-close',
                  'on-destroy',
                  'on-key-down',
                  'on-month-change',
                  'on-open',
                  'on-parse-config',
                  'on-ready',
                  'on-value-update',
                ]"
                class="appearance-none w-full h-10 border rounded px-3 text-black rounded-tr-none rounded-br-none"
                placeholder="Select Date"
                v-model="add_event.start_date"
                name="start_date"
                v-validate="'required'"
                :class="{ 'border-red': errors.has('add-event.start_date') }"
                ref="flatPickerAdd"
                tabindex="3"
              ></flat-pickr>
              <button
                type="button"
                class="text-white h-10 px-4 rounded-tr rounded-br"
                :class="[
                  errors.has('add-event.start_date') ? 'bg-red' : 'bg-brand',
                ]"
                data-toggle
              >
                <i class="fa fa-calendar-alt"></i>
              </button>
            </div>
            <div
              v-show="errors.has('add-event.start_date')"
              class="text-red text-sm mt-1"
            >
              {{ errors.first("add-event.start_date") }}
            </div>
          </div>
          <div class="flex-1 ml-0 md:ml-2 mt-4 md:mt-0">
            <label class="font-medium">Finish</label>
            <div class="flex mt-2">
              <flat-pickr
                v-if="isModalOpen"
                class="appearance-none w-full h-10 border rounded px-3 text-black rounded-tr-none rounded-br-none"
                placeholder="Select Date"
                :config="flatPickrConfig"
                :events="[
                  'on-change',
                  'on-close',
                  'on-destroy',
                  'on-key-down',
                  'on-month-change',
                  'on-open',
                  'on-parse-config',
                  'on-ready',
                  'on-value-update',
                ]"
                v-model="add_event.end_date"
                tabindex="4"
              ></flat-pickr>
              <button
                type="button"
                class="text-white h-10 px-4 rounded-tr rounded-br bg-brand"
                data-toggle
              >
                <i class="fa fa-calendar-alt"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="w-full text-left flex flex-col md:flex-row mb-4 mt-2">
          <div class="flex-1 mr-0 md:mr-2">
            <label class="font-medium">Recurring</label>
            <div class="flex mt-2 recurring">
              <multiselect
                ref="recurring"
                v-model="recurring"
                class="rounded"
                :class="{
                  'border-red': errors.has('add-event.selected_users'),
                }"
                track-by="id"
                :custom-label="recurringCustomLabel"
                :options="recurringOptions"
                :showLabels="false"
                name="recurring"
                v-validate="'required'"
                open-direction="below"
                :tabindex="5"
              >
              </multiselect>
            </div>
          </div>
          <div class="flex-1 ml-0 md:ml-2 mt-4 md:mt-0">
            <label class="font-medium">End Date</label>
            <div class="flex flex-col mt-2">
              <div class="flex w-full">
                <flat-pickr
                  v-if="isModalOpen"
                  name="recurring_end_date"
                  class="appearance-none w-full h-10 border rounded px-3 text-black rounded-tr-none rounded-br-none"
                  placeholder="Select Date"
                  :config="flatPickrConfigRecurring"
                  :events="[
                    'on-change',
                    'on-close',
                    'on-destroy',
                    'on-key-down',
                    'on-month-change',
                    'on-open',
                    'on-parse-config',
                    'on-ready',
                    'on-value-update',
                  ]"
                  v-model="add_event.recurring_end_date"
                  :disabled="!isRecurring"
                  tabindex="6"
                ></flat-pickr>
                <button
                  type="button"
                  class="text-white h-10 px-4 rounded-tr rounded-br bg-brand"
                  data-toggle
                >
                  <i class="fa fa-calendar-alt"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full text-left my-4">
          <label class="font-medium"
            >Notify <span class="text-red">*</span></label
          >
          <div class="flex flex-col md:flex-row my-2 text-sm">
            <label class="flex items-center mr-4">
              <input
                type="radio"
                name="type"
                v-model="send_to"
                value="all_member"
                class="mr-2 h-4 w-4 hover:cursor-pointer"
                @click="show_users = false"
                checked
              />
              All Vault members
            </label>
            <label class="flex items-center mr-4">
              <input
                type="radio"
                name="type"
                v-model="send_to"
                value="pick_users"
                class="mr-2 h-4 w-4 hover:cursor-pointer"
                @click="show_users = true"
                checked
              />
              Let me choose who receives it
            </label>
            <label class="flex items-center">
              <input
                type="radio"
                name="type"
                v-model="send_to"
                value="only_me"
                class="mr-2 h-4 w-4 hover:cursor-pointer"
                @click="show_users = false"
                checked
              />
              Don't notify anyone
            </label>
          </div>
          <div class="my-2" v-if="show_users">
            <multiselect
              v-model="selected_users"
              class="rounded"
              :class="{
                'border-red': errors.has('add-event.selected_users'),
              }"
              track-by="id"
              :custom-label="multiSelectCustomLabel"
              placeholder="Search a User"
              :options="vaultUsers"
              :showLabels="false"
              :hide-selected="true"
              name="selected_users"
              v-validate="'required'"
              open-direction="below"
              :multiple="true"
            >
              <template slot="tag" slot-scope="props">
                <span
                  class="bg-brand-lighter text-grey-dark rounded-lg py-1 mr-2"
                >
                  <span class="font-semibold text-xs px-2"
                    >{{ props.option.first_name }}
                    {{ props.option.last_name }}</span
                  >
                  <span
                    class="
                      text-brand
                      px-2
                      border-l border-brand-dark
                      hover:cursor-pointer
                    "
                    @click="props.remove(props.option)"
                  >
                    <i class="fa fa-times hover:text-brand-darker"></i>
                  </span>
                </span>
              </template>
            </multiselect>
            <div
              v-show="errors.has('add-event.selected_users')"
              class="text-red text-sm mt-1"
            >
              {{ errors.first("add-event.selected_users") }}
            </div>
          </div>
        </div>

        <div class="my-6">
          <file-upload
            ref="fileUpload"
            v-if="!vault.storage_exceeded"
          ></file-upload>
        </div>

        <div
          v-if="vault.storage_exceeded"
          class="
            mt-4
            bg-red-lightest
            border border-dashed
            w-full
            p-1
            border-red
            text-sm
          "
        >
          Vault Storage Exceeded, uploading is not allowed
        </div>

        <div class="mt-6 flex justify-between items-center">
          <button
            class="bg-brand border border-brand text-white text-sm font-medium py-2 px-4 rounded hover:bg-brand-dark hover:border-brand-dark"
            type="submit"
          >
            <i class="fa fa-plus mr-2"></i> Add
          </button>
        </div>
      </form>
    </div>
  </sweet-modal>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import FileUpload from "../FileUpload.vue";

export default {
  name: "AddEvent",
  props: ["user", "vault", "vaultUsers"],
  components: {
    flatPickr,
    FileUpload,
  },
  data() {
    return {
      isModalOpen: false,
      add_event: {},
      send_to: "only_me",
      show_users: false,
      selected_users: [],
      recurring: {
        id: 0,
        label: "Doesn't Repeat",
      },
      recurringOptions: [
        {
          id: 0,
          label: "Doesn't Repeat",
        },
        {
          id: 1,
          label: "Weekly",
        },
        {
          id: 2,
          label: "Monthly",
        },
        {
          id: 3,
          label: "Annually",
        },
      ],
      flatPickrConfig: {
        wrap: true,
        allowInput: false,
        dateFormat: "d/m/Y h:i K",
        enableTime: true,
        monthSelectorType: "static",
      },
      flatPickrConfigRecurring: {
        wrap: true,
        allowInput: false,
        dateFormat: "d/m/Y",
        enableTime: false,
        monthSelectorType: "static",
      },
    };
  },
  methods: {
    recurringCustomLabel(option) {
      return option.label;
    },
    postEvent() {
      this.$validator.validateAll("add-event").then((result) => {
        if (result) {
          this.$emit("processing", true);

          let end_at = "";
          const start_at = moment(
            this.add_event.start_date,
            "DD/MM/YYYY HH:mm A"
          ).format("YYYY-MM-DD HH:mm:ss");
          if (this.add_event.end_date) {
            end_at = moment(
              this.add_event.end_date,
              "DD/MM/YYYY HH:mm A"
            ).format("YYYY-MM-DD HH:mm:ss");
          }

          let participant_user_ids = [];

          if (this.send_to == "all_member") {
            participant_user_ids = _.map(this.vaultUsers, "id");
          }

          if (this.send_to == "pick_users") {
            participant_user_ids = _.map(this.selected_users, "id");
          }

          if (this.send_to == "only_me") {
            participant_user_ids = [this.user.id];
          }

          let recurring_end_date = "";
          if (this.add_event.recurring_end_date) {
            recurring_end_date = moment(
              this.add_event.recurring_end_date,
              "DD/MM/YYYY"
            ).format("YYYY-MM-DD");
          }

          const formData = new FormData();
          formData.append("title", this.add_event.title);
          formData.append("description", this.add_event.description);
          formData.append("start_at", start_at);
          formData.append("end_at", end_at);
          formData.append("recurring", this.recurring.id);
          formData.append("recurring_end_date", recurring_end_date);
          participant_user_ids.forEach((id, index) => {
            formData.append(`participant_user_ids[${index}]`, id);
          });

          const files = this.$refs.fileUpload.getFiles();
          const vaultFiles = this.$refs.fileUpload.getVaultFiles();
          files.forEach((file, index) => {
            formData.append(`files[${index}]`, file);
          });
          vaultFiles.forEach((file, index) => {
            formData.append(`vault_files[${index}]`, file.id);
          });

          axios
            .post(
              `api/vaults/${this.$route.params.vault_id}/events`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then(() => {
              this.$emit("eventAdded");
              this.add_event = {};
            })
            .finally(() => {
              this.$emit("processing", false);
              this.$refs.modal.close();
            });
        }
      });
    },
    onModalOpen() {
      this.isModalOpen = true;
      this.resetState();
    },
    modalClosed() {
      this.isModalOpen = false;
      this.resetState();
      this.$refs.fileUpload.cleanup();
    },
    resetState() {
      this.add_event = {
        title: "",
        description: "",
        start_date: "",
        end_date: "",
        recurring_end_date: "",
      };
      this.recurring = {
        id: 0,
        label: "Doesn't Repeat",
      };
      this.send_to = "only_me";
      this.show_users = false;
      this.errors.clear("add-event");
    },
    multiSelectCustomLabel(user) {
      if (!user.last_name) {
        return user.first_name;
      }
      return user.first_name + " " + user.last_name;
    },
  },
  watch: {
    send_to(value) {
      if (value == "pick_users") {
        this.selected_users = [];
        if (this.selected_event && this.selected_event.users) {
          this.selected_users = [...this.selected_event.users];

          const foundIndex = this.selected_event.users.findIndex(
            (user) => user.id == this.user.id
          );

          if (foundIndex < 0) {
            this.selected_users.push(this.user);
          }
        } else {
          this.selected_users.push(this.user);
        }
      }
    },
    recurring(value) {
      if (value && value.id == 0) {
        this.add_event.recurring_end_date = "";
      }
    },
  },
  computed: {
    isRecurring() {
      if (this.recurring) {
        return this.recurring.id != 0;
      }
      return false;
    },
  },
};
</script>

<style scoped>
button:focus {
  outline: none;
}

/* Recurring select: the same 40px as the date inputs beside it. The unscoped
   .multiselect__tags padding in SearchDocuments.vue makes it 47px otherwise. */
.recurring >>> .multiselect,
.recurring >>> .multiselect__tags {
  min-height: 2.5rem;
  height: 2.5rem;
}
.recurring >>> .multiselect__tags {
  padding: 0.5rem 2.5rem 0 0.5rem !important;
}
.recurring >>> .multiselect__single,
.recurring >>> .multiselect__placeholder {
  margin-bottom: 0;
}
</style>